import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ProfileState {
    firstName: string | null;
    lastName: string | null;
    email: string | null;
    mobile: string | null;
}

const initialState: ProfileState = {
    firstName: null,
    lastName: null,
    email: null,
    mobile: null,
};

const profileSlice = createSlice({
    name: 'profile',
    initialState,
    reducers: {
        setProfileData: (state, action: PayloadAction<ProfileState>) => {
            state.firstName = action.payload.firstName;
            state.lastName = action.payload.lastName;
            state.email = action.payload.email;
            state.mobile = action.payload.mobile;
        },
        clearProfileData: (state) => {
            state.firstName = null;
            state.lastName = null;
            state.email = null;
            state.mobile = null;
        },
    },
});

export const { setProfileData, clearProfileData } = profileSlice.actions;

export default profileSlice.reducer;
